import "./App.css";
import Router from "./Router/Router";

function App() {
  return (
    <div className="">
      <Router></Router>
    </div>
  );
}

export default App;
